import request from '@/utils/request';
/* 信息 */
export function infoWatch (data) {
  return request({
    url: '/config/fetchOrderConfigDetail',
    method: 'POST',
    data
  });
}
/* 新增/修改 */
export function update (data) {
  return request({
    url: '/config/saveOrUpdateOrderConfig',
    method: 'POST',
    data
  });
}
/* 获取文本配置信息 */
export function privacyWatch (data) {
  return request({
    url: '/config/fetchAgreementConfigDetail',
    method: 'POST',
    data
  });
}
/* 新增或修改文本配置信息 */
export function updatePrivacy (data) {
  return request({
    url: '/config/saveOrUpdateAgreementConfig',
    method: 'POST',
    data
  });
}
/* 获取会员配置信息 */
export function vipWatch (data) {
  return request({
    url: '/config/fetchMemberConfigDetail',
    method: 'POST',
    data
  });
}
/* 新增或修改会员配置信息 */
export function updateVip (data) {
  return request({
    url: '/config/saveOrUpdateMemberConfig',
    method: 'POST',
    data
  });
}
/* 获取背景图配置信息 */
export function bgImgWatch (data) {
  return request({
    url: '/config/fetchBackgroundImageConfigDetail',
    method: 'POST',
    data
  });
}
/* 新增或修改背景图配置信息 */
export function updateBgImg (data) {
  return request({
    url: '/config/saveOrUpdateBackgroundImageConfig',
    method: 'POST',
    data
  });
}
/* 自提点列表 */
export function pickupList(data) {
  return request({
    url: '/pickup/address/queryPickupAddressPageList',
    method: 'POST',
    data
  });
}
/* 增加自提点 */
export function pickupAdd(data) {
  return request({
    url: '/pickup/address/savePickupAddress',
    method: 'POST',
    data
  });
}
/* 修改自提点 */
export function pickupEdit(data) {
  return request({
    url: '/pickup/address/updatePickupAddress',
    method: 'POST',
    data
  });
}
/* 修改自提点中的信息展示 */
export function pickupInfo(data) {
  return request({
    url: '/pickup/address/fetchPickupAddressDetailById',
    method: 'POST',
    data
  });
}
/* 删除自提点 */
export function pickupDel(data) {
  return request({
    url: '/pickup/address/removePickupAddressById',
    method: 'POST',
    data
  });
}
/* 配送列表 */
export function deliveryList(data) {
  return request({
    url: '/goods/move/template/queryGoodsMoveTemplatePageList',
    method: 'POST',
    data
  });
}
/* 删除配送 */
export function deliveryDel(data) {
  return request({
    url: '/goods/move/template/removeGoodsMoveTemplateById',
    method: 'POST',
    data
  });
}
/* 新增配送 */
export function deliveryAdd(data) {
  return request({
    url: '/goods/move/template/saveDeliveryGoodsMoveTemplate',
    method: 'POST',
    data
  });
}
/* 编辑配送 */
export function deliveryEdit(data) {
  return request({
    url: '/goods/move/template/updateGoodsMoveTemplate',
    method: 'POST',
    data
  });
}
/* 配送信息显示 */
export function deliveryInfo(data) {
  return request({
    url: '/goods/move/template/fetchGoodsMoveTemplateDetailById',
    method: 'POST',
    data
  });
}
/* 新增或修改商品配置 */
export function saveOrUpdateGoodsConfig(data) {
  return request({
    url: '/config/saveOrUpdateGoodsConfig',
    method: 'POST',
    data
  });
}
/* 获取商品配置数据 */
export function fetchGoodsConfigDetail(data) {
  return request({
    url: '/config/fetchGoodsConfigDetail',
    method: 'POST',
    data
  });
}
/* 管理员-用户信息表列表 */
export function queryManagementUserPageList(data) {
  return request({
    url: '/management/user/queryManagementUserPageList',
    method: 'POST',
    data
  });
}
/* 管理员-修改密码 */
export function updatePassword(data) {
  return request({
    url: '/management/user/updatePassword',
    method: 'POST',
    data
  });
}
/* 管理员-删除 */
export function removeManagementUserById(data) {
  return request({
    url: '/management/user/removeManagementUserById',
    method: 'POST',
    data
  });
}
/* 管理员-新增 */
export function saveManagementUser(data) {
  return request({
    url: '/management/user/saveManagementUser',
    method: 'POST',
    data
  });
}
/* 管理员-修改 */
export function updateManagementUser(data) {
  return request({
    url: '/management/user/updateManagementUser',
    method: 'POST',
    data
  });
}
/* 管理员-修改明细 */
export function fetchManagementUserDetailById(data) {
  return request({
    url: '/management/user/fetchManagementUserDetailById',
    method: 'POST',
    data
  });
}
/* 管理员-所有角色状态正常的角色信息列表 */
export function queryAllRoleList(data) {
  return request({
    url: '/role/queryAllRoleList',
    method: 'POST',
    data
  });
}
/* 角色管理-获取角色信息列表 */
export function queryRolePageList(data) {
  return request({
    url: '/role/queryRolePageList',
    method: 'POST',
    data
  });
}
/* 角色管理-删除 */
export function removeRoleById(data) {
  return request({
    url: '/role/removeRoleById',
    method: 'POST',
    data
  });
}
/* 角色管理-新增 */
export function saveRole(data) {
  return request({
    url: '/role/saveRole',
    method: 'POST',
    data
  });
}
/* 角色管理-修改 */
export function updateRole(data) {
  return request({
    url: '/role/updateRole',
    method: 'POST',
    data
  });
}
/* 角色管理-修改明细 */
export function fetchRoleDetailById(data) {
  return request({
    url: '/role/fetchRoleDetailById',
    method: 'POST',
    data
  });
}
/* 角色管理-获取树形结构系统菜单列表 */
export function queryMenuTreeList(data) {
  return request({
    url: '/menu/queryMenuTreeList',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/setting.js